import React from 'react';
import Text from './base';

const H5 = props => <Text tag="h5" variant="h5" {...props} />;

export default H5;
